<template>
    <b-container fluid="">
        <button type="button" class="btn btn-sm btn-outline-dark listado-btn"
            v-if="permisos['registro_desperdicio.reporte']?.ver || datos_usuario.parametros.roles.includes('ROOT')"
            @click="mostrarListado = true">
            Registros
        </button>
        <button type="button" class="btn btn-sm btn-outline-dark listado-btn" v-else disabled>
            Registros
        </button>
        <b-row>
            <div class="col-sm-12 mt-2">
                <h3>
                    Registro de desperdicio
                </h3>
            </div>
            <div class="col-sm-3 mt-3">
                <label for="" class="form-label">Máquina</label>
                <select class="form-control form-control-sm" v-model="maquina" required>
                    <option value="">Seleccionar</option>
                    <option v-for="(item, index) in maquinas" :key="index" :value="item.id">{{ item.nombre }}
                    </option>
                </select>
            </div>
            <div class="col-sm-3 mt-3">
                <label for="" class="form-label">Tipo Rollo</label>
                <select class="form-control form-control-sm" v-model="rollo" required>
                    <option value="">Seleccionar</option>
                    <option v-for="(item, index) in tipos_de_rollo" :key="index" :value="item.id">{{ item.nombre }}
                    </option>
                </select>
            </div>
            <div class="col-sm-3 mt-3">
                <label for="" class="form-label">Metraje</label>
                <select class="form-control form-control-sm" v-model="metraje" required>
                    <option value="">Seleccionar</option>
                    <option value="1">Metros</option>
                </select>
            </div>
            <div class="col-sm-3 mt-3">
                <label for="" class="form-label">Fecha</label>
                <input type="date" class="form-control form-control-sm" v-model="fecha" required>
            </div>
            <div class="col-sm-8 mt-3">
                <label for="" class="form-label">Código</label>
                <input type="text" id="campo_codigo_articulo" list="listado_articulos__"
                    class="form-control form-control-sm" @keydown.tab="consulta_producto_por_codigo"
                    v-model="codigo_producto">

                <datalist id="listado_articulos__">
                    <option v-for="(item, index) in FILTRAR_PRODUCTOS_POR_SUCURSAL" :key="index" :value="item.codigo">{{
                        item.nombre }}
                    </option>
                </datalist>
            </div>

            <div class="col-sm-2 mt-3">
                <label for="" class="form-label">Cantidad</label>
                <input type="number" step="0.01" min="1" class="form-control form-control-sm" v-model="cantidad">
            </div>
            <div class="col-sm-2 mt-5">
                <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                    @click="agregar_al_carrito">Agregar</button>
            </div>
            <div class="col-sm-12 mt-3">
                <div class="contenedor_texto_articulo">
                    {{ nombre_articulo }}
                </div>
            </div>
            <div class="col-sm-12 mt-3">
                <div class="marco_registro_merma_N">
                    <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                        <thead>
                            <tr>
                                <th style="width: 15%;">
                                    Código
                                </th>
                                <th style="width: 65%;">
                                    Descripción
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    Cantidad
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    ...
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in carrito" :key="index">
                                <td>
                                    {{ item.codigo }}
                                </td>
                                <td>
                                    {{ item.nombre }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.cantidad }}
                                </td>
                                <td style="text-align: center;">
                                    <button type="button" style="font-size: 11px;" class="btn btn-sm btn-outline-dark"
                                        @click="eliminar_del_carrito(index)"><i class="fas fa-trash"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-sm-9 mt-3">
                <label for="" class="form-label">Comentarios</label>
                <textarea class="form-control form-control-sm" required v-model="comentarios" rows="3"></textarea>
            </div>
            <div class="col-sm-3 mt-5">
                <button type="button" style="height: 100%;" class="btn btn-sm btn-outline-dark btn-block"
                    v-if="permisos['registro_desperdicio']?.crear || datos_usuario.parametros.roles.includes('ROOT')"
                    @click="guardar_registro_merma">Registrar</button>
                <button type="button" style="height: 100%;" class="btn btn-sm btn-outline-dark btn-block" v-else
                    disabled>Registrar</button>
            </div>
        </b-row>

        <!-- Modal de Listado de Mermas -->
        <ListadoDeMermas v-if="mostrarListado" @salir="cerrarListado" />
    </b-container>
</template>

<script>
    import moment from 'moment';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import { minix } from '../functions/alertas';
    import ListadoDeMermas from './ListadoDeMermas.vue';

    export default {
        name: 'RegistroN',
        components: {
            ListadoDeMermas
        },
        computed: {
            ...mapState(['datos_usuario', 'maquinas', 'tipos_de_rollo', 'id_empresa_seleccionada', 'permisos']),
            ...mapGetters(['FILTRAR_PRODUCTOS_POR_SUCURSAL'])
        },
        data() {
            return {
                codigo_producto: '',
                nombre_articulo: '-',
                cantidad: 1,
                fecha: moment(Date.now()).format('YYYY-MM-DD'),
                comentarios: '',
                carrito: [],
                producto_seleccionado: {},
                maquina: '',
                rollo: '',
                metraje: '',
                mostrarListado: false
            }
        },
        methods: {
            cerrarListado() {
                this.mostrarListado = false;
            },
            async consulta_producto_por_codigo() {
                let f = {
                    api: `articulos?filters[codigo][$eq][0]=${this.codigo_producto}&filters[sucursal][$eq][1]=${this.datos_usuario.sucursal_asignada}&filters[formula][$eq][2]=false&filters[activo][$eq][3]=true&filters[empresa][$eq][4]=${this.id_empresa_seleccionada}`,
                }

                let r = await this.obtener_data(f)
                if (r.length == 0) {
                    minix({ icon: 'info', mensaje: 'Producto no encontrado', tiempo: 3000 })
                    document.getElementById('campo_codigo_articulo').select()
                } else {
                    this.nombre_articulo = r[0].nombre
                    this.producto_seleccionado = r[0]
                }
            },
            agregar_al_carrito() {
                if (this.nombre_articulo == '-' || this.nombre_articulo == '') {
                    minix({ icon: 'error', mensaje: 'Producto no seleccionado', tiempo: 3000 })
                    document.getElementById('campo_codigo_articulo').select()
                } else {
                    let f = {
                        codigo: this.producto_seleccionado.codigo,
                        nombre: this.producto_seleccionado.nombre,
                        cantidad: this.cantidad
                    }

                    this.carrito.push(f)

                    this.codigo_producto = ''
                    this.nombre_articulo = '-'
                    this.cantidad = 1

                    document.getElementById('campo_codigo_articulo').focus()

                }
            },
            async guardar_registro_merma() {

                let fecha_limite_hacia_atras = moment().subtract(6, 'days').format('YYYY-MM-DD')
                let fecha_actual = moment().format('YYYY-MM-DD')

                if (this.fecha < fecha_limite_hacia_atras) {
                    minix({ icon: 'error', mensaje: 'La fecha no puede ser menor a 6 dias', tiempo: 3000 })
                } else if (this.fecha > fecha_actual) {
                    minix({ icon: 'error', mensaje: 'La fecha no puede ser mayor a la actual', tiempo: 3000 })
                } else {

                    if (this.maquina == '' || this.rollo == '' || this.metraje == '' || this.comentarios == '') {
                        minix({ icon: 'error', mensaje: 'Todos los campos son requeridos', tiempo: 3000 })

                    } else {
                        if (this.carrito.length == 0) {
                            minix({ icon: 'error', mensaje: 'No se pueden registrar merma sin productos', tiempo: 3000 })

                        } else {
                            let f = {
                                api: 'mermas/g/registro_merma',
                                formulario: {
                                    maquina: this.maquina,
                                    rollo: this.rollo,
                                    metraje: this.metraje,
                                    fecha: this.fecha,
                                    comentarios: this.comentarios,
                                    items: this.carrito,
                                    sucursal: this.datos_usuario.sucursal_asignada,
                                    empresa: this.id_empresa_seleccionada
                                }

                            }

                            await this.guardar_data(f)
                            this.maquina = ''
                            this.rollo = ''
                            this.metraje = ''
                            this.carrito = []
                            this.comentarios = ''

                        }


                    }
                }


            },
            eliminar_del_carrito(index) {
                this.carrito.splice(index, 1)
            },
            setear_sucursal_origen() {
                // ESTO ES PARA QUE FILTRE LOS PRODUCTOS POR SUCURSAL
                this.set_filtro_productos_sucursales_traslados(parseInt(this.datos_usuario.sucursal_asignada))

            },
            ...mapActions(['obtener_data', 'guardar_data']),
            ...mapMutations(['set_filtro_productos_sucursales_traslados'])
        },
        mounted() {
            this.setear_sucursal_origen()
        },
    }
</script>

<style>
    .marco_registro_merma_N {
        width: 100%;
        height: calc(100vh - 450px);
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        overflow: auto;
    }

    .listado-btn {
        position: absolute;
        top: 55px;
        right: 15px;
        z-index: 999;
    }
</style>